// extracted by mini-css-extract-plugin
module.exports = {"illustration":"MiniCard_illustration__COkcL","title":"MiniCard_title__Zwq_s","header":"MiniCard_header__Qxn6Q","mini":"MiniCard_mini__juMXC"};